import { faSpinner, faSignOutAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FunctionComponent, memo } from "react";

import "./client-sign-out.scss";
import { IProps } from "./client-sign-out.types";

/**
 * Sign out button.
 * @param props.isLoading   If the button is in a loading state
 * @param props.onClick     The callback to run when the button is clicked
 * @returns The sign out button
 */
const ClientSignout: FunctionComponent<IProps> = ({ isLoading, onClick }) => {
    return (
        <li className="client-sign-out navigation-link" onClick={isLoading ? undefined : onClick}>
            <div className="navigation-link__inner">
                <FontAwesomeIcon spin={isLoading} icon={isLoading ? faSpinner : faSignOutAlt} />
                Sign Out
            </div>
        </li>
    );
};

export default memo(ClientSignout);
